import React from "react";
import useHover from "../../hooks/useHover";

const Wrapper = ({
  as: Component = "div",
  style: propStyle,
  className,
  type,
  disableHoverOutline = false,
  myProfile = "false",
  manageDevice = "false",
  isAudio = false, // ✅ NEW PROP
  ...props
}) => {
  const { isHovered, handleMouseEnter, handleMouseLeave } = useHover();

  return (
    <Component
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className={`${className || ""} no-focus-outline`}
      style={{
        ...propStyle,
        outline:
          type !== "referral-button" && !disableHoverOutline
            ? isHovered
              ? isAudio
                ? "4px solid #EC008C" // ✅ Audio hover outline
                : "4px solid #ffffff" // default hover outline
              : propStyle?.outline
            : "none",
        cursor: "pointer",
        ...(myProfile === "true"
          ? { borderRadius: "15px" }
          : manageDevice === "true"
          ? { borderRadius: "11px" }
          : {}),
      }}
      {...props}
    >
      {props.children}
    </Component>
  );
};

export default Wrapper;
